import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-add-button',
    templateUrl: './add-button.component.html',
    styleUrls: ['./add-button.component.scss'],
    standalone: false
})
export class AddButtonComponent implements OnInit {
  @Input() public disabled: boolean;
  @Input() public outlined: boolean = false;
  @Input() public icon: string = "add";

  @Output() public onClick: EventEmitter<Event> = new EventEmitter<Event>();

  public constructor() {}

  public ngOnInit(): void {}

  public handleClick(event: Event): void {
    this.onClick.emit(event);
  }
}
